import { render, staticRenderFns } from "./SubCategories.vue?vue&type=template&id=c6939d26&scoped=true&"
import script from "./SubCategories.vue?vue&type=script&lang=js&"
export * from "./SubCategories.vue?vue&type=script&lang=js&"
import style0 from "./SubCategories.vue?vue&type=style&index=0&id=c6939d26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6939d26",
  null
  
)

export default component.exports